/** Where the super admin is, mirrored into location.hash so browser Back/Forward and shared links work. */
export interface AdminRoute {
	tab: string
	company?: string
	section?: string
	card?: string
	user?: string
}

const enc = encodeURIComponent

export const formatAdminRoute = ({ tab, company, section, card, user }: AdminRoute): string => {
	let path = `#/${tab}`
	if (tab === "company" && company) {
		path = `#/company/${enc(company)}`
		if (card) path += `/card/${enc(card)}`
		else if (section) path += `/${enc(section)}`
	}
	return user ? `${path}?user=${enc(user)}` : path
}

export const parseAdminRoute = (hash: string, isTab: (tab: string) => boolean, fallback = "companies"): AdminRoute => {
	const [path, query = ""] = hash.replace(/^#\/?/, "").split("?")
	const parts = path.split("/").filter(Boolean).map(decodeURIComponent)
	const user = new URLSearchParams(query).get("user") || undefined
	if (parts[0] === "company" && parts[1]) {
		if (parts[2] === "card" && parts[3]) return { tab: "company", company: parts[1], card: parts[3], user }
		return { tab: "company", company: parts[1], section: parts[2], user }
	}
	return { tab: parts[0] && isTab(parts[0]) ? parts[0] : fallback, user }
}
